import InProgressEngagements from '@dashboardWirelineRetentionDepartment/InProgressEngagements/InProgressEngagements';

export default InProgressEngagements;
